module.exports = __webpack_public_path__ + "static/media/61C3dzUaVPL._AC_UX569_.5c501ccd.jpg";